import React from 'react';

const CalendarIcon = () => (
  <svg
    width="13px"
    height="14px"
    viewBox="0 0 13 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-993.000000, -223.000000)"
        fill="#78707C"
        fillRule="nonzero"
      >
        <g transform="translate(975.000000, 204.000000)">
          <g>
            <g transform="translate(18.000000, 19.000000)">
              <path d="M1.00000119,12.9999917 L12.0000143,12.9999917 L12.0000143,4.99999166 L1.00000119,4.99999166 L1.00000119,12.9999917 Z M4.00000358,3.49998689 L4.00000358,1.24998719 C4.00000358,1.10936202 3.89062964,0.999986887 3.75000447,0.999986887 L3.25000387,0.999986887 C3.10937871,0.999986887 3.00000358,1.10936202 3.00000358,1.24998719 L3.00000358,3.49998689 C3.00000358,3.64061503 3.10937871,3.74999017 3.25000387,3.74999017 L3.75000447,3.74999017 C3.89062964,3.74999017 4.00000358,3.64061503 4.00000358,3.49998689 Z M10.0000107,3.49998689 L10.0000107,1.24998719 C10.0000107,1.10936202 9.89063679,0.999986887 9.75001162,0.999986887 L9.25001103,0.999986887 C9.10938586,0.999986887 9.00001073,1.10936202 9.00001073,1.24998719 L9.00001073,3.49998689 C9.00001073,3.64061503 9.10938586,3.74999017 9.25001103,3.74999017 L9.75001162,3.74999017 C9.89063679,3.74999017 10.0000107,3.64061503 10.0000107,3.49998689 Z M13.0000155,2.99998569 L13.0000155,13.0000012 C13.0000155,13.5468768 12.54689,14.0000024 12.0000143,14.0000024 L1,14.0000024 C0.45312554,14.0000024 0,13.5468768 0,13.0000012 L0,2.99998569 C0,2.45311362 0.45312554,1.99998569 1,1.99998569 L2,1.99998569 L2,1.24998719 C2,0.562486365 2.56250305,-1.43051147e-05 3.25000387,-1.43051147e-05 L3.75000447,-1.43051147e-05 C4.43750529,-1.43051147e-05 5,0.562486365 5,1.24998719 L5,1.99998569 L8,1.99998569 L8,1.24998719 C8,0.562486365 8.56251021,-1.43051147e-05 9.25001103,-1.43051147e-05 L9.75001162,-1.43051147e-05 C10.4375124,-1.43051147e-05 11.0000131,0.562486365 11.0000131,1.24998719 L11.0000131,1.99998569 L12.0000143,1.99998569 C12.54689,1.99998569 13.0000155,2.45311362 13.0000155,2.99998569 Z"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CalendarIcon;
